"use client";

import { useState } from "react";
import { useDetectClickOutside } from "react-detect-click-outside";
import { useRouter } from "@bprogress/next";
import { useSearchParams } from "next/navigation";
import { Button } from "@/components/ui/button";
import { ChevronDownIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export const Sort = ({
  sortOptions,
  className,
  defaultLabel = "domyślnie",
}: {
  sortOptions: SortOption[];
  className?: string;
  defaultLabel?: string;
}) => {
  const [visibility, setVisible] = useState(false);
  const ref = useDetectClickOutside({
    onTriggered: () => {
      setVisible(false);
    },
  });

  const router = useRouter();
  const searchParams = useSearchParams();

  const currentSort = searchParams.get("sort");
  const currentSortOrder = searchParams.get("sortOrder");

  const clearSort = () => {
    const params = new URLSearchParams(searchParams.toString());
    params.delete("sort");
    params.delete("sortOrder");

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    router.push(newUrl, { scroll: false });
    setVisible(false);
  };

  const setSort = ({ sort, sortOrder }: SortOption) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("sort", sort);
    params.set("sortOrder", sortOrder);

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    router.push(newUrl, { scroll: false });
    setVisible(false);
  };

  return (
    <div
      className={cn("relative z-1", className)}
      onClick={() => setVisible(true)}
    >
      <Button
        variant={"ghost"}
        className={"w-full font-normal hover:scale-100!"}
      >
        Sortuj:{" "}
        <span className={`first-letter:uppercase`}>
          {sortOptions.find(
            (option) =>
              option.sort == currentSort &&
              option.sortOrder === currentSortOrder,
          )?.title ?? defaultLabel}
        </span>
        <ChevronDownIcon size={"16px"} />
      </Button>
      <div
        className={cn(
          `pointer-events-none absolute top-8 z-[1] w-full rounded-[var(--12,12px)] bg-white px-[10px] py-2 opacity-0 shadow-[0px_4px_42px_0px_rgba(0,0,0,0.05)]`,
          visibility && "pointer-events-auto opacity-100",
        )}
        ref={ref}
      >
        <div
          className={cn(
            `px-2 py-[7.5px] text-sm leading-[17px] font-normal text-[#333] not-italic`,
            "hover:text-remedium-blue transition-all first-letter:uppercase hover:cursor-pointer hover:bg-[#f9fafc]",
            !currentSort &&
              !currentSortOrder &&
              `text-remedium-blue bg-[#f9fafc]`,
          )}
          onClick={clearSort}
        >
          {defaultLabel}
        </div>
        {sortOptions.map((sortOption) => {
          const isActive =
            sortOption.sort === currentSort &&
            sortOption.sortOrder === currentSortOrder;
          return (
            <div
              key={sortOption.title}
              className={cn(
                `px-2 py-[7.5px] text-sm leading-[17px] font-normal text-[#333] not-italic`,
                "hover:text-remedium-blue transition-all first-letter:uppercase hover:cursor-pointer hover:bg-[#f9fafc]",
                isActive && `text-remedium-blue bg-[#f9fafc]`,
              )}
              onClick={() => setSort(sortOption)}
            >
              {sortOption.title}
            </div>
          );
        })}
      </div>
    </div>
  );
};
